<article class="run" [class.open]="expanded">
  <div class="run-line">
    <button type="button" class="run-row" [attr.aria-expanded]="expanded" [attr.aria-controls]="'run-detail-' + run.runId"
      (click)="onHeaderClick($event)">
      <mat-icon class="run-chev" aria-hidden="true">chevron_right</mat-icon>
      <span class="run-name">
        <run-source-badge [source]="runInfo.source"></run-source-badge>
        <span class="run-title" [title]="run.name">{{ runInfo.displayName }}</span>
      </span>
      <span class="run-by" [title]="run.initiatedBy">{{ run.initiatedBy }}</span>
      <span class="run-when" [title]="(latestRunHistory?.eventTime | date: 'dd MMM yyyy, HH:mm:ss z') ?? ''">
        {{ latestRunHistory?.eventTime | date: 'd MMM yyyy' }}<span class="run-time">{{ latestRunHistory?.eventTime | date: 'HH:mm' }}</span>
      </span>
      <span class="run-status">
        @if (run.optimisationResult) {
          <status-badge [status]="run.optimisationResult.status"></status-badge>
        } @else {
          <status-badge [status]="latestRunHistory?.status"></status-badge>
        }
      </span>
      <span class="run-pnl">
        @if (run.optimisationResult) {
          <pnl [monetaryValue]="run.optimisationResult.pnL" [suffix]="true"></pnl>
          @if (pnlDeltaInfo) {
            <span class="run-delta" [class.up]="pnlDeltaInfo.delta >= 0" [class.down]="pnlDeltaInfo.delta < 0" [title]="deltaTooltip">
              {{ pnlDeltaInfo.delta >= 0 ? '+$' : '−$' }}{{ (pnlDeltaInfo.delta >= 0 ? pnlDeltaInfo.delta : -pnlDeltaInfo.delta) | number: '1.2-2' }}M vs Freight Base
            </span>
            @if (pnlDeltaInfo.breakevenTcRate !== null) {
              <span class="run-be">BE TC ${{ pnlDeltaInfo.breakevenTcRate | number: '1.0-0' }}k/day × {{ pnlDeltaInfo.tcDays }} days</span>
            }
          }
        } @else {
          <span class="run-nil">—</span>
        }
      </span>
    </button>
    <span class="run-go">
      @if (canCompare) {
        <a class="run-go-link" [routerLink]="['/mti-comparison']" [queryParams]="mtiQuery ?? { after: run.runId }"
          ngbTooltip="MTI Compare" placement="top" aria-label="Open in MTI Compare"><mat-icon aria-hidden="true">compare_arrows</mat-icon></a>
        <a class="run-go-link" [routerLink]="['/pnl-explain']" [queryParams]="{ current: run.runId }"
          ngbTooltip="P&amp;L Explain" placement="top" aria-label="Open in P&amp;L Explain"><mat-icon aria-hidden="true">query_stats</mat-icon></a>
        <a class="run-go-link" [routerLink]="['/gantt']" [queryParams]="{ run: run.runId }"
          ngbTooltip="Gantt" placement="top" aria-label="Open in the Gantt"><mat-icon aria-hidden="true">view_timeline</mat-icon></a>
      }
    </span>
  </div>

  @if (expanded) {
    <div class="run-detail" [id]="'run-detail-' + run.runId">
      <dl class="run-facts">
        <div>
          <dt>Run ID</dt>
          <dd>
            <span class="run-mono">{{ run.runId }}</span>
            <button mat-icon-button class="mat-icon-button-sm run-copy" ngbTooltip="Copied" triggers="click:click" [closeDelay]="1500"
              (click)="copyRunId()" aria-label="Copy run ID"><mat-icon>content_copy</mat-icon></button>
          </dd>
        </div>
        @if (runHistoriesAsc?.length) {
          <div>
            <dt>Timeline</dt>
            <dd class="run-timeline">
              @for (h of runHistoriesAsc; track $index) {
                <span>{{ h.status | status }} <span class="run-timeline-at">{{ h.eventTime | date: 'HH:mm:ss' }}</span></span>
              }
            </dd>
          </div>
        }
        @if (elapsedTime) {
          <div><dt>Elapsed time</dt><dd class="run-num">{{ elapsedTime }}</dd></div>
        }
        @if (run.optimisationResult) {
          <div><dt>P&amp;L (detailed)</dt><dd><pnl [monetaryValue]="run.optimisationResult.pnL"></pnl></dd></div>
          @if (run.optimisationResult.outputFilePath) {
            <div class="run-fact-wide">
              <dt>Output file</dt>
              <dd>
                <span class="run-mono run-path">{{ run.optimisationResult.outputFilePath }}</span>
                <button mat-icon-button class="mat-icon-button-sm run-copy" ngbTooltip="Copied" triggers="click:click" [closeDelay]="1500"
                  (click)="copyOutputFilePath()" aria-label="Copy output file path"><mat-icon>content_copy</mat-icon></button>
              </dd>
            </div>
          }
        }
      </dl>
      @if (canCompare) {
        <div class="run-actions">
          <a class="go-btn" [routerLink]="['/mti-comparison']" [queryParams]="mtiQuery ?? { after: run.runId }">
            <mat-icon aria-hidden="true">compare_arrows</mat-icon>MTI Compare
          </a>
          <a class="go-btn" [routerLink]="['/pnl-explain']" [queryParams]="{ current: run.runId }">
            <mat-icon aria-hidden="true">query_stats</mat-icon>P&amp;L Explain
          </a>
          <a class="go-btn" [routerLink]="['/gantt']" [queryParams]="{ run: run.runId }">
            <mat-icon aria-hidden="true">view_timeline</mat-icon>Gantt
          </a>
        </div>
      } @else {
        <p class="run-why">{{ notComparableReason }}</p>
      }
    </div>
  }
</article>
